import { FlowDurationUnits } from 'flow-schema';

export function getDefaultServiceReviewConfig() {
  return {
    submissionMode: '',
    payorPortal: '',
    patientInsuranceId: '',
    patientOrder: '',
    customPayload: '',
    fileReference: '',
    caseId: '',
    description: '',
    timeout: {
      value: 1,
      units: FlowDurationUnits.Hours,
    },
    isTest: true,
  };
}
